import { render, staticRenderFns } from "./the-reasons.vue?vue&type=template&id=8a43be18&scoped=true"
import script from "./the-reasons.vue?vue&type=script&lang=js"
export * from "./the-reasons.vue?vue&type=script&lang=js"
import style0 from "./the-reasons.vue?vue&type=style&index=0&id=8a43be18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a43be18",
  null
  
)

export default component.exports